import type { FaireProductEntity } from "../../entity_types/product";

export const p_zwday2mk5r: FaireProductEntity = {
  token: "p_zwday2mk5r",
  type: "product",
  name: "Baddie Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/c2d5a8059b5df8970fe1f686e78a5f296357ffdc6698891a50508e377a054f49.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a3a472bcd3d22d03c5a5502efc98a0a25256d3aa025bc60ead66df9860cf451e.jpeg",
    "https://cdn.faire.com/fastly/6958c174efe91fa2d44623be26adaa0381a665473fc9a1f03582714aa710f696.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/3a3ec3f0442922598223ab0104eb72467a9ebe5238719ac9eade24ef25f697bf.jpeg",
    "https://cdn.faire.com/fastly/62789610c1279d1d268564aafcfb522a61ac91323083938981fc593f3531cf37.jpeg",
    "https://cdn.faire.com/fastly/4a1ecff4fcb0bb336f9a4a92e0447be2e507841399ba0f29c32694140f68dfc6.jpeg",
    "https://cdn.faire.com/fastly/c30776043e4d2a84eedd03d92805bcd95fc0a54f72cfaaf4adc1e346c47f837e.jpeg"
  ],
  priceDollars: 6.75,
  description: "Every step you take reverberates confidence. Strut your stuff in these comfy socks, Baddie.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:27:50.978Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
